import { AccountService } from './account.service';
import { Cliente } from './../model/cliente.model';
import { HttpClient } from '@angular/common/http';
import { environment } from './../../environments/environment';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators'

import Swal, { SweetAlertIcon } from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class ClientesService {

  baseUrl = environment.baseUrl;

  constructor(private http: HttpClient, private serviceAccount: AccountService) { }

  getAllClientes(params: any): Observable<any>{
    const url = `${this.baseUrl}clientes`;
    return this.http.get<any>(url, {params})
  }

  listarServiceClientes(): Observable<Cliente[]>{
    const url = `${this.baseUrl}clientes/listarTodos`;
    return this.http.get<Cliente[]>(url);
  }

  listarIdService(id: any): Observable<Cliente>{
    const url = `${this.baseUrl}clientes/${id}`
    return this.http.get<Cliente>(url);
  }

  cadastrarService(cliente: Cliente): Observable<Cliente>{
    const url = `${this.baseUrl}clientes/cadastro`;
    return this.http.post<Cliente>(url, cliente);
  }

  atualizarService(cliente: Cliente): Observable<Cliente>{
    const url = `${this.baseUrl}clientes/atualizar/${cliente.sr_id}`;
    return this.http.put<Cliente>(url, cliente);
  }

  statusService(clientes: Cliente): Observable<any>{
    var status = new Object();
    status = {'status': clientes.bl_status}
    const url = `${this.baseUrl}clientes/status/${clientes.sr_id}`;
    return this.http.put<any>(url, status)
  }

  public confirmAlert(cliente: any): void {
    Swal.fire({
      title: 'Desativar cliente?',
      showCancelButton: true,
      confirmButtonColor: '#00AA5B',
      cancelButtonColor: '#df4747',
      confirmButtonText: 'Confirmar'
    }).then((result) => {
      if (result.isConfirmed) {
        cliente.bl_status = 0;
        this.statusService(cliente).subscribe((resp) => {})
      }
    })
  }

  public desativarAlert(cliente: any): void {
    Swal.fire({
      title: 'Ativar cliente?',
      showCancelButton: true,
      confirmButtonColor: '#00AA5B',
      cancelButtonColor: '#df4747',
      confirmButtonText: 'Confirmar!'
    }).then((result) => {
      if (result.isConfirmed) {
        cliente.bl_status = 1;
        this.statusService(cliente).subscribe((resp) => {})
      }
    })
  }


  listarClientesEmComumEntreUsuarios(idsUsuarios:string){
    const url = `${this.baseUrl}agrupamentos-clientes/usuarios/${idsUsuarios}`;
    return this.http.get<Cliente[]>(url);
  }

  

}
